import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, LayoutDashboard, Shield } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center group" data-testid="nav-logo">
            <img src="/icon-nav.png" alt="Local Luc" className="h-12 w-12 rounded-xl object-cover transition-transform duration-200 group-hover:scale-105" />
          </Link>

          {user && (
            <div className="flex items-center gap-4">
              <Link to="/dashboard" data-testid="nav-dashboard-link" className="flex items-center gap-1.5 text-sm text-[#64748B] hover:text-[#0F2951] transition-colors">
                <LayoutDashboard className="w-4 h-4" strokeWidth={1.5} />
                <span className="hidden sm:inline">Projects</span>
              </Link>
              {user.role === 'super_admin' && (
                <Link to="/admin" data-testid="nav-admin-link" className="flex items-center gap-1.5 text-sm text-[#0268C4] hover:text-[#015BA8] transition-colors">
                  <Shield className="w-4 h-4" strokeWidth={1.5} />
                  <span className="hidden sm:inline">Admin</span>
                </Link>
              )}
              <span className="text-sm text-[#64748B] hidden sm:inline">{user.name || user.email}</span>
              <Button
                data-testid="nav-logout-button"
                variant="ghost"
                size="sm"
                onClick={handleLogout}
                className="text-[#64748B] hover:text-[#0F2951] hover:bg-[#EFF3F8] rounded-xl"
              >
                <LogOut className="w-4 h-4" strokeWidth={1.5} />
              </Button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
